import type { GameState, SaveState } from './types'
import { COMPETITION_VERSION } from './competition'

export const WORKING_KEY = 'bfs-working-state.v56'
export const MATCHDAY_KEY = 'bfs-matchday-autosave.v56'
export const SAVE_VERSION = COMPETITION_VERSION

const hasValidCompetition = (gameState: GameState): boolean => {
  const season = gameState.season
  const rounds = new Set(season?.fixtures?.map(fixture => fixture.round) ?? [])
  return Boolean(
    season
    && Object.keys(season.teams ?? {}).length === 19
    && season.fixtures?.length === 171
    && rounds.size === 19,
  )
}

export const decodeWorkingState = (raw: string | null): SaveState | null => {
  if (!raw) return null
  try {
    const value = JSON.parse(raw) as Partial<SaveState>
    if (value.version !== SAVE_VERSION || !value.gameState || typeof value.timestamp !== 'number' || !hasValidCompetition(value.gameState)) return null
    return value as SaveState
  } catch {
    return null
  }
}

export const decodeMatchdayState = (raw: string | null): SaveState | null => {
  if (!raw) return null
  try {
    const value = JSON.parse(raw) as Partial<SaveState>
    if (value.version !== SAVE_VERSION || !value.gameState || typeof value.timestamp !== 'number' || !hasValidCompetition(value.gameState)) return null
    return value as SaveState
  } catch {
    return null
  }
}

export const encodeCurrentSave = (gameState: GameState, timestamp: number): string =>
  JSON.stringify({ version: SAVE_VERSION, gameState, timestamp } satisfies SaveState)

export const saveWorkingState = (gameState: GameState): void => {
  window.localStorage.setItem(WORKING_KEY, encodeCurrentSave(gameState, Date.now()))
}

export const saveMatchdayState = (gameState: GameState): void => {
  window.localStorage.setItem(MATCHDAY_KEY, encodeCurrentSave(gameState, Date.now()))
}

export const clearWorkingState = (): void => {
  window.localStorage.removeItem(WORKING_KEY)
}

export const clearMatchdayState = (): void => {
  window.localStorage.removeItem(MATCHDAY_KEY)
}
